module.exports = __webpack_public_path__ + "img/55_56.062dd567.png";